

import { Coordinate, VideoOverlayObject } from '../VideoPlayer/VideoTypes';
import BallMarker from './BallMarker';

type Props = {
  coord: Coordinate,
  lifetime: number,
  inAir: boolean,
}

const BallActionMarker = (props: Props) => {
  const {
    coord,
    lifetime,
    inAir,
  } = props;

  const overlayObjects: VideoOverlayObject[] = BallMarker({
    coord: coord,
    color: '#444',
    inAir: inAir,
    lifetime: lifetime,
  });

  return overlayObjects;
}

export default BallActionMarker;